import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// Simple analytics function (can be replaced with actual analytics)
const trackPageView = () => {
  if (window.location.hostname !== 'localhost') {
    console.log('Page view tracked:', window.location.pathname);
    // Here you would typically call your analytics service
  }
};

// Add analytics event listener (optional)
if (typeof window !== 'undefined') {
  window.addEventListener('load', trackPageView);
}

// Get root element
const rootElement = document.getElementById('root');

// Ensure root element exists
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// Create and render root
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);
